import { AddFactorResponse, ChallengeResponse, DXLError, EnrollResponse, LoginStatusResponse, PortalLoginResponse, ValidateResponse } from "./be_interfaces"

export interface MockUnit {
    login?: PortalLoginResponse,
    retrieveUser?: any,
    createChallenge?: ChallengeResponse,
    addFactor?: AddFactorResponse | DXLError,
    verifyOTP?: ValidateResponse,
    loginStatus?: LoginStatusResponse,
    enroll?: EnrollResponse | DXLError
}


export const mock_responses: { [key: string]: MockUnit } =

{
    'SIMPLE_LOGIN': {
        login: {
            "status": 201,
            "market": "Business"
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'SMS',
                    label: 'DECONDO NUMERO',
                    profileSms: {
                        msisdn: '24783445',
                        language: 'Italian'
                    },

                }, {
                    id: '3',
                    kind: 'SMS',
                    label: 'NUMERO DI RISERVA',
                    profileSms: {
                        msisdn: '355865299',
                        language: 'Italian'
                    },

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'SIMPLE_LOGIN_SINGLE': {
        login: {
            "status": 201,
            "market": "Business"
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'SIMPLE_SINGLE_LOGIN': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'MULTICONTACT_LOGIN': {
        login: {
            "status": 201,
            "market": "Business"
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'SMS',
                    label: 'DECONDO NUMERO',
                    profileSms: {
                        msisdn: '24783445',
                        language: 'Italian'
                    },

                }, {
                    id: '3',
                    kind: 'EMAIL',
                    label: 'mail',
                    profileEmail: {
                        email: 'mrossi@gmail.com',
                        language: 'Italian'
                    },

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'EMAIL_LOGIN': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'EMAIL',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileEmail: {
                        email: "giancarlo.sanna@consultant.vodafoneomnitel.it",
                        language: 'Italian'
                    }

                }
            ],
            defaultFactorId: '2',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "email",
                "profileEmail": {
                    "email": "ciccio@gmail.com",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'USER_PENDING': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'pending',
            callStatus: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    profileSms: {
                        msisdn: '+393461368705',
                        language: 'Italian'
                    },
                    validated: false

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "sms",
                profileSms: {
                    msisdn: "+393331234567",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+392361368705",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'USER_PENDING_DOUBLE': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'pending',
            callStatus: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    profileSms: {
                        msisdn: '+393461368705',
                        language: 'Italian'
                    },
                    validated: false

                }, {
                    id: '2',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    profileSms: {
                        msisdn: '+39345667799',
                        language: 'Italian'
                    },
                    validated: false

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "sms",
                profileSms: {
                    msisdn: "+393331234567",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+392361368705",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'CONSUMER': {
        login: {
            "status": 200
        },
    }, 
     'PWD_CHANGE': {
        login: {
            "status": 403,
            "errorCode": "OTP_NO_CHANGE",
            "location": "https://www.google.com"
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'SMS',
                    label: 'DECONDO NUMERO',
                    profileSms: {
                        msisdn: '24783445',
                        language: 'Italian'
                    },

                }, {
                    id: '3',
                    kind: 'SMS',
                    label: 'NUMERO DI RISERVA',
                    profileSms: {
                        msisdn: '355865299',
                        language: 'Italian'
                    },

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'WRONG_OTP': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'SMS',
                    label: 'DECONDO NUMERO',
                    profileSms: {
                        msisdn: '24783445',
                        language: 'Italian'
                    },

                }, {
                    id: '3',
                    kind: 'SMS',
                    label: 'NUMERO DI RISERVA',
                    profileSms: {
                        msisdn: '355865299',
                        language: 'Italian'
                    },

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'KO',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }

    },
    'LOGIN_ENROLL': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ]

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "sms",
                profileSms: {
                    msisdn: "+39334762345",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
    },
    'EMAIL_ENROLL': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ],
            mailFactorEnabled: true

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "email",
                profileEmail: {
                    email: "ciccio@gmail.com",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
    }, 'EMAIL_ENROLL_BUG': {
        login: {
            "status": 201
        },
        retrieveUser: {
            "authToken": "eyJraWQiOiJ2ZmE6bG9naW4iLCJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiMjIzYjM5OWMxNWNkMmRjYWQ4NjUwNDNkMGQwMDNlMSIsImF1ZCI6ImR4bCIsImlzcyI6ImxvZ2luIiwic3ViIjoiZXlKaGRIUnlhV0oxZEdWeklqcDdJblZ6WlhKdVlXMWxJam9pWVdGdFpXUXpNRFZBWjIxaGFXd3VZMjl0SWl3aWNHRnlkSGxKWkNJNklrbFVOVEEyTkRNNE5EWWlmWDA9IiwiY2xhaW1zIjp7Im1hcmtldCI6ImJ1c2luZXNzIiwic2VjdXJpdHlMZXZlbCI6IjIwIiwicHJvZmlsZUlkIjoiUFJPU1BFQ1QiLCJjdXN0b21lcklkIjoiMjI3MDkzMzUiLCJyb2xlIjoicHJvc3BlY3QifSwic2VjcmV0cyI6bnVsbCwic2NvcGUiOiJlMzA9IiwiZXhwIjoxNzUxNTQ4Mzk4fQ.QtU9NYOhsWczq2KnykA1wHmaTW4HAHPSqQ8Ae96B-5W9KCrO9SOY8HX-Ok_A_J0DBnBPW6HLAByRcPXNenVw-lQn2f-wh-SJjETDF--k_vDsgRSDWn0TFn4-An1-Obymm04v8bpfFOREhd_YKn8N022AN5qGZnJeGb8iPtmm7Dbs_r9iOFukuaGItR9oijwP1rtC1AfZ46RJwPK2xJOwqsjOWLCbxDB2TVgeIFuOgn7sVSa2ZqSLirgrediq7u09luWSq0sTGe8C0bbUa3TZ7dYi519GITLmP_bVsckH-LBzmjAR-GmaPnGI6O3tz2RLtyq0_UgXfeGETZwujytrOToNcBR59B3O-USKrOcPb3OfF98kvAcSniaQmNYvgt623xX_baR9DMNLZqGrjpPs6nkGNacBcU0yJvlxvAyXRFBECg94GrR36ZGgY_fLKxXS-NWRvfXLJKT7YOgFWai1fUOfGqeifAD2lyZwZV4XQQDWFgSMQ_vBFPy3dhCt3fSAXxgJyX-P7zThabw5mpKZXRlgQtx73-fJNSJRaRQyn2xlDxR2y1l9rt3DjPWbXom87AERLRrDsw3QEGZOAH1wQeoV3GYOjHT_RpTXJp4dZfGb6XvbY43eUweLD74yQDViX-yENUSOgRUl7jDMYa2sY1Ti3lgoLhzNLhK4p8Uu3p4",
            "name": "",
            "authFactors": [
                {
                    "id": "34fde2004d22b354c1507ea4aab7400b",
                    "kind": "email",
                    "verified": true
                }
            ],
            "defaultFactorId": "34fde2004d22b354c1507ea4aab7400b",
            "mailFactorEnabled": false
        },
        addFactor: {
            "id": "c202126a8e4070e26a4d177abf54702a",
            "factor": {
                "id": "34fde2004d22b354c1507ea4aab7400b",
                "kind": "email",
                "verified": true,
                "profileSms": {},
                "profileEmail": {}
            },
            "status": "pending"
        },
        createChallenge: {
            "id": "c202126a8e4070e26a4d177abf54702a",
            "factor": {
                "id": "34fde2004d22b354c1507ea4aab7400b",
                "kind": "email",
                "verified": true,
                "profileSms": {},
                "profileEmail": {}
            },
            "status": "pending"
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "email",
                profileEmail: {
                    email: "ciccio@gmail.com",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
    },
    'EMAIL_ENROLL_NONUM': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
            ],
            mailFactorEnabled: true

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "email",
                profileEmail: {
                    email: "ciccio@gmail.com",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
    }, '_ENROLL_VaL': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: false,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'EMAIL',
                    label: 'PRIMO NUMERO',
                    verified: false,
                    profileEmail: {
                        email: "ciccio@gmail.com",
                        language: 'Italian'
                    }

                }
            ],
            defaultFactorId: '2',
            regNumbers: null,
            mailFactorEnabled: true
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "email",
                "profileEmail": {
                    "email": "ciccio@gmail.com",
                    "lang": 'Italian'
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        }
    },
    'EMAIL_ENROLL_ERROR_MD': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ],
            mailFactorEnabled: true
        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "error": "DXL409",
            "messageId": "authenticator:invalid-factor-email",
            "reason": "The provided factor email address cannot be the same of the registration email. Factor email address [employee_pre4_3472929011@mail.it]."
        },
    },
    'EMAIL_ENROLL_ERROR_MI': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ],
            mailFactorEnabled: true
        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "error": "DXL400",
            "messageId": "invalid-profile-email",
            "reason": "Provided factor email address[<email>] is not valid"
        },
    },
    'EMAIL_ENROLL_ERROR_MR': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ],
            mailFactorEnabled: true
        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "error": "DXL409",
            "messageId": "authenticator:too-many-factors",
            "reason": "Provided factor email address[<email>] is not valid"
        },
    },
    'EMAIL_ENROLL_ERROR_MC': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ],
            mailFactorEnabled: true
        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "error": "DXL409",
            "reason": ""
        },
    },
    'LOGIN_CONTACTNUMS_ENROLL': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'contactNums': [
                '336663456',
                '396536666'
            ]

        },
        addFactor: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "sms",
                profileSms: {
                    msisdn: "+39334762345",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
    },
    'EMAIL_ENROLL_ERROR_ADD': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'pending',
            callStatus: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    profileSms: {
                        msisdn: '+393461368705',
                        language: 'Italian'
                    },
                    validated: false

                }
            ],
            defaultFactorId: '1',
            mailFactorEnabled: true
        },
        addFactor: {
            "error": "DXL400",
            "description": ""
        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "error": "DXL400",
            "description": ""
        },
    },
    'LOGIN_ENROLL_2': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ]

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "id": "7f2f323a4c0949bedcfb44d58554755c",
            "status": "pending",
            "factor": {
                "id": "7cf662069732db2668c22e335bd1056d",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393461368705",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "aws"
            },
            "validateResultSms": {},
            "authorization": {
                "header": "vf-a-customer-identification"
            }

        },
    },
    'LOGIN_ENROLL_NO_NUMBERS': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
            ]

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            "id": "7f2f323a4c0949bedcfb44d58554755c",
            "status": "pending",
            "factor": {
                "id": "7cf662069732db2668c22e335bd1056d",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393461368705",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "aws"
            },
            "validateResultSms": {},
            "authorization": {
                "header": "vf-a-customer-identification"
            }

        },
    },
    'LOGIN_ENROLL_WRONG_NUMBER': {
        login: {
            "status": 201
        },
        retrieveUser: {
            status: 'OK',
            'picassoNumsNonDXL': [
                '334762345',
                '396536656'
            ]

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '734hv432g234gjhg43jhg234h4g4g4j43gjh34ghj43h4g4gjhg4jh3g4jg4j3K'
        },
        enroll: {
            status: 'KO',
            "code": "authenticator:log",
            "reason": "Validation failed",
            "details": [{
                "target": "factor.profileSms.msisdn",
                "message": "Must respect [E164] format."
            }]
        },
    },
    'TEST_LOGIN_1': {
        login: {
            "status": 201
        },
        retrieveUser: {
            "status": 'OK',
            "authToken": "hdjhjhadhdkjh",
            "name": "ProvaNome",
            "surname": "ProvaCognome",
            "authFactors": [{
                "id": "1",
                "kind": "sms",
                "label": "Prova",
                "profileSMS": {
                    "msisdn": "3400000000",
                    "language": "ITA"
                },
                "profileEmail": null
            }],
            "defaultFactorId": "1"
        },
        enroll: {
            factor: {
                id: "0776441c7d54b7072cbed67257136fcd",
                kind: "sms",
                profileSms: {
                    msisdn: "+393331234567",
                    lang: "it-IT"
                },
                label: "Personal Number"
            },
            id: "726656175671671",
            status: "pending"
        },
        verifyOTP: {
            status: 'OK',
            authToken30: 'JG443J434HJ3JK43GJ4KJ4G4KG3JG4K3JG4KJG4JK4G4JK4GK43M4N3B4NM44V4BBM4CBN34CN44322443243'
        }
    },
    'LOGIN_FAIL': {
        login: {
            "status": 403,
            "errorCode": "BLX_ACCOUNT_PENDING",
            "location": "https://www.google.com"
        },
        retrieveUser: {
            status: 'KO',


        }
    },
    'LOGIN_FAIL_CONSUMER': {
        login: {
            "status": 403,
            "errorCode": "CONSUMER_NOT_MIGRATED",
            "location": ""
        },
        retrieveUser: {
            status: 'KO',


        }
    },
    'LOGIN_FAIL_OTPCANGE': {
        login: {
            "status": 403,
            "errorCode": "OTP_CHANGE",
            "location": "https://www.google.com"
        },
        retrieveUser: {
            status: 'OK',
            authToken: 'xxxxxxxxx',
            name: 'Rossi',
            surname: 'Mario',
            authFactors: [
                {
                    id: '1',
                    kind: 'SMS',
                    label: 'PRIMO NUMERO',
                    verified: true,
                    profileSms: {
                        msisdn: '34567899',
                        language: 'Italian'
                    }

                },
                {
                    id: '2',
                    kind: 'SMS',
                    label: 'DECONDO NUMERO',
                    profileSms: {
                        msisdn: '24783445',
                        language: 'Italian'
                    },

                }, {
                    id: '3',
                    kind: 'SMS',
                    label: 'NUMERO DI RISERVA',
                    profileSms: {
                        msisdn: '355865299',
                        language: 'Italian'
                    },

                }
            ],
            defaultFactorId: '1',
            regNumbers: null

        },
        createChallenge: {
            "id": "70c071adf868ea64a8ca82fa0e276df6",
            "status": "pending",
            "factor": {
                "id": "006ddad46c2a56943eaa0bce3df3efb4",
                "kind": "sms",
                "profileSms": {
                    "msisdn": "+393331234567",
                    "lang": "it-IT"
                },
                "verified": false,
                "label": "Personal Number"
            },
            "createResultSms": {
                "provider": "otpchallenge"
            },
            "validateResultSms": {}
        },
        verifyOTP: {
            status: 'OK',
            authToken30: '76w786eqw7ew7q8678ewq678ewq'
        }
    },
    'ALREADY_LOGGED': {
        loginStatus: {
            loginStatus: 'LOGGED'
        }
    },
    'WRONG_PASSWORD': {
        login: {
            status: 401,
            errorCode: 'NBL_PASSWORD_INVALID',
            diagnostic: 'Invalid password'
        }
    },
    'LAST_ATTEMPT': {
        login: {
            status: 401,
            errorCode: 'NBL_PWD_LAST_ATTEMPT_REMAIN',
            diagnostic: 'Invalid password'
        }
    },
    'ACC_PENDING': {
        login: {
            status: 403,
            errorCode: 'OTP_CHANGE/BL_ACCOUNT_PENDING',
            diagnostic: 'per reimpostare pwd',
            location: 'https://www.vodafone.it'
        }
    },
    'ATTEMPT_EXCED': {
        login: {
            status: 401,
            errorCode: 'NBL_PWD_ATTEMPTS_EXCEEDED',
            diagnostic: 'per reimpostare pwd',
            location: 'https://www.vodafone.it'
        }
    }



}